import createInformesSectionPage from "./SectionPageFactory";

const InformesProduccionPage = createInformesSectionPage(
  "Producción",
  "Supervisá órdenes, capacidad instalada y rendimientos por línea de producción."
);

export default InformesProduccionPage;
